var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 583,
    height: 440,
    viewBox: "0 0 583 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_11423)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.793 117.858H426.95V360.255H102.793V117.858Z",
    fill: "#7D8FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7227 112.807H431.258V360.255H97.7227V112.807Z",
    stroke: "white",
    strokeWidth: 9.59223,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4727 618.923H1490.39V-80.2637H-28.4727V618.923Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_11423)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0078 360.255H552.003",
    stroke: "white",
    strokeWidth: 14.3883,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4688 618.925H1490.4V-80.2617H-28.4688V618.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_75_11423)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M549.948 119.077L357.664 263.192",
    stroke: "#F8EC30",
    strokeWidth: 4.31472,
    strokeLinejoin: "round",
    strokeDasharray: "5.94 5.94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M355.505 256.714L349.027 269.664L363.273 267.079L355.505 256.714Z",
    fill: "#F8EC30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4648 618.925H1490.4V-80.2617H-28.4648V618.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_75_11423)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.113 180.077H439.502V282.394H425.113V180.077Z",
    fill: "#17375E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4609 618.925H1490.4V-80.2617H-28.4609V618.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_75_11423)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.062 277.676H392.302",
    stroke: "white",
    strokeWidth: 4.31472,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.457 618.925H1490.41V-80.2617H-28.457V618.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_75_11423)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.203 280.438H381.5V356.742H270.203V280.438Z",
    fill: "#F8F7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4531 618.925H1490.41V-80.2617H-28.4531V618.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_75_11423)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M441.433 165.688L440.887 292.141",
    stroke: "#F8EC30",
    strokeWidth: 6.71575,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4492 618.925H1490.41V-80.2617H-28.4492V618.925Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_75_11423)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0017 126.042L97.7461 318.635",
    stroke: "#F8EC30",
    strokeWidth: 14.3883,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_75_11423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -29,
    y: -81,
    width: 1520,
    height: 700
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.4453 618.925H1490.42V-80.2617H-28.4453V618.925Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_75_11423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.614 267.157L112.848 205.532",
    stroke: "#F8EC30",
    strokeWidth: 4.31472,
    strokeLinejoin: "round",
    strokeDasharray: "6.54 6.54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.043 212.354L102.523 202.406L116.787 199.957L113.043 212.354Z",
    fill: "#F8EC30"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_11423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 582.634,
    height: 439.531,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.7b0331a8b337cd7413857762dab32f61.svg";
export { ForwardRef as ReactComponent };